import {openResourceModal} from '../../core/modalCommand';
import {
	USER_CREATE_MODAL_EVENT,
	USER_DELETE_MODAL_EVENT,
	USER_EDIT_MODAL_EVENT,
	USER_SUSPEND_MODAL_EVENT,
} from './events';

/**
 * Open Edit User for the resolved row.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openUserEditModal(command, envelope) {
	return openResourceModal(USER_EDIT_MODAL_EVENT, command, envelope);
}

/**
 * Open the Suspend User confirmation.
 *
 * The confirmation, not the suspension. Nothing changes until the person
 * presses the button inside it - which is why this capability is declared
 * destructive rather than read: a read capability would be worked
 * automatically, and this one must not be.
 *
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openUserSuspendModal(command, envelope) {
	return openResourceModal(USER_SUSPEND_MODAL_EVENT, command, envelope);
}

/**
 * Open the Delete User confirmation. Same contract as suspend.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openUserDeleteModal(command, envelope) {
	return openResourceModal(USER_DELETE_MODAL_EVENT, command, envelope);
}

/**
 * Open Add User - the empty form, with nothing filled in.
 *
 * The Add forms are deliberately not mapped field by field, so the agent
 * opens the form and the person fills it.
 *
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openUserCreateModal(command, envelope) {
	return openResourceModal(USER_CREATE_MODAL_EVENT, command, envelope);
}
